import { FluxStandardAction } from 'redux-promise-middleware';
import { ActionTypes as SoundActionTypes } from '../actions/soundActions';

const STORAGE_KEY = 'PlaySounds';

const initialState = localStorage.getItem(STORAGE_KEY) === 'true';

export default (state = initialState, action: FluxStandardAction) => {
  switch (action.type) {

    case SoundActionTypes.EnableSounds: {
      localStorage.setItem(STORAGE_KEY, 'true');
      return true;
    }

    case SoundActionTypes.DisableSounds: {
      localStorage.setItem(STORAGE_KEY, 'false');
      return false;
    }

  }

  return state;
};
